import React from "react";
import { useAuth } from "./AuthContext";
import "../stili/Header.css";

export default function Header() {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    localStorage.clear();
    sessionStorage.clear();

    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    window.location.href = "/login";
  };

  return (
    <header className="header-container">
      <div className="header-left">
        <div className="header-title">Gestionale Calcio</div>
        <div className="header-user">
          {user?.ruolo ? `Utente: ${user.ruolo}` : "Utente non loggato"}
        </div>
      </div>

      {user?.accessToken && (
        <button className="header-logout" onClick={handleLogout}>
          Logout
        </button>
      )}
    </header>
  );
}